// extracted by mini-css-extract-plugin
export default {"th":"View_th__Nf-6U","td":"View_td__YOVwY","button":"View_button__Hk3fx","input":"View_input__XVPjL","btn_icon":"View_btn_icon__T2mqB","btn_active":"View_btn_active__sIc4w"};